import TabPanel from '../../../common/components/tabPanel';
import Tabs, { TabItem } from '../../../common/components/tabs';
import { commonTestIds } from '../../../common/utils/commonTestIds';
import { OrderViewerTab } from '../typing/enums';
import CitationDetailsTab from './orderViewerTabs/citationDetailsTab';
import OrderDetailsTab from './orderViewerTabs/orderDetailsTab';
import PanelHeader from './orderViewerTabs/panelHeader';
import { createStyles, makeStyles } from '@mui/styles';
import { inject } from 'mobx-react';
import { useState } from 'react';

const useStyles = makeStyles(() =>
	createStyles({
		panel: {
			paddingTop: '0.75rem',
			paddingBottom: '0.5rem'
		},
		tabs: {
			display: 'flex',
			flexDirection: 'column',
			overflow: 'hidden',
			paddingLeft: '0.75rem',
			paddingRight: '0.75rem',
			width: '342px',
			flex: '1 0 0'
		}
	})
);

export interface IOrderTabsProps {
	selectedTab?: number;
	onCollapse: () => void;
}

const OrderTabs: React.FunctionComponent<IOrderTabsProps> = props => {
	const classes = useStyles();
	const [selectedTab, setSelectedTab] = useState(
		props.selectedTab === OrderViewerTab.Default ? OrderViewerTab.OrderDetails : props.selectedTab
	);

	const tabs: TabItem[] = [];

	tabs.push({ title: localize('Order details'), tabIndex: 1 });
	tabs.push({ title: localize('Citation details'), tabIndex: 2 });
	return (
		<div className={classes.tabs} data-test-id={commonTestIds.viewerDetails}>
			<PanelHeader title={localize('Details')} onClose={() => props.onCollapse()} />
			<Tabs
				small={true}
				onChange={id => {
					setSelectedTab(id);
				}}
				tabIndex={selectedTab}
				items={tabs}
			>
				<TabPanel
					tabIndex={OrderViewerTab.OrderDetails}
					selectedTabIndex={selectedTab}
					className={classes.panel}
				>
					<OrderDetailsTab />
				</TabPanel>
				<TabPanel
					tabIndex={OrderViewerTab.CitationDetails}
					selectedTabIndex={selectedTab}
					className={classes.panel}
				>
					<CitationDetailsTab />
				</TabPanel>
			</Tabs>
		</div>
	);
};

export default inject(() => ({
	selectedTab: 0
}))(OrderTabs);
